import { useIsLoggedIn } from '@zoopla/user';
import { Homepage, HomepageProps } from './Homepage';

export const LoggedOutHomepage = (props: Omit<HomepageProps, 'isLoggedIn'>) => {
    const isLoggedIn = useIsLoggedIn();

    return <Homepage isLoggedIn={isLoggedIn} {...props} />;
};
